import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const theme = {
  primary: '#0484f0',
  secondary: '#43A047',
  accent: '#9C27b0',
  info: '#00CAE3',
};

export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    themes: {
      dark: theme,
      light: theme,
    },
  },
});
